import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { H2 } from '@repo/ui/components/Typography';

import { GenerationResultCard } from '../generationResultCard';

import { HeaderCenter, ResultsGrid, ResultsWrapper } from './styles';
import { AiTextToolResultsProps } from './types';

const renderGenerationCardsSkeleton = (buttonText: string, length = 8) => {
  return Array.from({ length }).map((_, index) => (
    <GenerationResultCard
      key={index}
      buttonLabel={buttonText}
      isLoading={true}
      text=""
    />
  ));
};

const AiTextToolResults: React.FC<AiTextToolResultsProps> = ({
  title,
  results,
  isLoading,
  buttonText,
}) => {
  return (
    <ResultsWrapper>
      <HeaderCenter>
        <H2>{title}</H2>
      </HeaderCenter>
      <ResultsGrid>
        {isLoading
          ? renderGenerationCardsSkeleton(buttonText, results.length)
          : results.map((result, index) => (
              <GenerationResultCard
                key={index}
                buttonLabel={buttonText}
                isLoading={false}
                text={result.text}
              />
            ))}
      </ResultsGrid>
    </ResultsWrapper>
  );
};

export default withEventScope(AiTextToolResults, {
  feature: 'aiTextToolResults',
});
